<div class="dashboard-container">
  <gridster [options]="options" class="gridster-container">
    <gridster-item *ngFor="let widget of widgets" [item]="widget" class="widget">
      <bpc-chartwidget *ngIf="widget.type === WidgetTypes.chart"  [title]="widget.title" [loaders]="widget.loaders" [chartType]="widget.chartType"/>
      <bpc-rankingwidget *ngIf="widget.type === WidgetTypes.rankings"  [title]="widget.title" [filters]="widget.filters" [loaders]="widget.loaders"/>
      <bpc-deal-drop-widget *ngIf="widget.type === WidgetTypes.dealdrop"  [title]="widget.title" [loaders]="widget.loaders"/>
    </gridster-item>
  </gridster>
</div>
